import styled from 'styled-components';

export const ButtonLink = styled.div`
  color: ${props => props.theme.colors.link};
  margin-bottom: 20px;
  cursor: pointer;
`;
